__webpack_require__.p = "/semantic-data-catalog/";